import { request } from '@/api/core';
import * as BreedTypes from '@/@types/breedTypes';

/**
 * Start processing unresolved breeds from the preprocessor output
 * @param {string} taskId The matcher task ID to begin processing for
 * @returns {Promise<BreedTypes.MatcherBreedState>} The matcher breed state associated with the task
 */
export const startUnresolvedBreedsProcessing = (taskId) => {
  return request('breeds/process-unresolved', {
    method: 'POST',
    data: {
      taskId
    }
  });
};

/**
 * Fetches breeds with a given breedStateId
 * @param {number} breedStateId ID of a breed state to find all breed entries for
 * @returns {Promise<BreedTypes.MatcherBreed[]>} The breeds with the matching breedStateID
 */
export const fetchBreeds = (breedStateId) => {
  return request('breeds', {
    method: 'GET',
    params: {
      breedStateId
    }
  });
};

/**
 * Update properties of a stored breed
 * @param {number} id Breed ID of breed to update
 * @param {BreedTypes.MatcherBreed} updatedPart Fields of matcher breed to update with values to set
 * @returns {Promise<BreedTypes.MatcherBreed>} The complete updated matcher breed object
 */
export const updateBreed = (id, updatedPart) => {
  return request(`breeds/${id}`, {
    method: 'PATCH',
    data: updatedPart
  });
};

/**
 * Marks the breeds state resolved
 * @param {number} breedsStateId The ID of the breed state to mark resolved
 * @returns {Promise<BreedTypes.MatcherBreedState>} The
 */
export const resolveBreeds = (breedsStateId) => {
  return request(`breeds/resolve/${breedsStateId}`, {
    method: 'POST'
  });
};

/**
 * Upload resolved breeds from the matcher to the import session data
 * @param {number} breedsStateId The ID of the breed state to upload from
 * @returns {Promise<BreedTypes.MatcherBreedState>} The breed state that data was uploaded for
 */
export const uploadResolvedBreeds = (breedsStateId) => {
  return request(`breeds/resolve/${breedsStateId}/upload`, {
    method: 'POST'
  });
};
